import Uri from "./jsuri";

export default Uri;
